module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue),
      expression: "localValue"
    }],
    staticClass: "form-control",
    attrs: {
      "name": _vm.name
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.localValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.change],
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.includeOffBudget == 'true') ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Off Budget Transaction")]) : _vm._e(), _vm._v(" "), (_vm.includeIncome) ? _c('optgroup', {
    attrs: {
      "label": "Income"
    }
  }, [_vm._l((_vm.incomes), function(inc) {
    return _c('option', {
      domProps: {
        "value": inc.source
      }
    }, [_vm._v(_vm._s(inc.source))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Other Income")])], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('optgroup', {
      attrs: {
        "label": group.name
      }
    }, _vm._l((group.categories), function(cat) {
      return _c('option', {
        domProps: {
          "value": cat.id
        }
      }, [(!cat.in_active_budget) ? [_vm._v("(NOT ACTIVE) ")] : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(cat.description) + "\n\t\t")], 2)
    }))
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-219c7ab7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupsCategoriesSelect.vue
// module id = 157
// module chunks = 1